export const formatByHashes = (mask: string, value: string) => {
  let i = 0;
  return mask.replace(/#/g, () => value[i++] || '');
};

export const formatSnils = (snils?: string | number) => {
  if (!snils) return '';

  return formatByHashes('###-###-### ##', snils.toString());
};

export const formatOMS = (oms?: string | number) => {
  if (!oms) return '';

  return formatByHashes('#### #### #### ####', oms.toString());
};

export const formatUsc = (usc?: string | number, hidden?: boolean) => {
  if (!usc) return '';
  let uscString = usc.toString();

  if (hidden) {
    uscString = '●●●●●●●●●●●●' + uscString.slice(12);
  }
  return formatByHashes('#### #### #### ####', uscString);
};

export const formatPhone = (phone?: string) => {
  if (!phone) {
    return '';
  }
  const digits = phone.replace(/\D/g, '');

  switch (digits.length) {
    case 10:
      return formatByHashes('(###) ### ## ##', digits);

    case 11:
      return digits[0] === '7'
        ? formatByHashes('8 (###) ### ## ##', digits.slice(1))
        : digits === '88006000670'
        ? formatByHashes('#-###-####-###', digits)
        : formatByHashes('# (###) ### ## ##', digits);
    default:
      return digits;
  }
};

export const formatUrl = (url?: string) => {
  if (!url) {
    return '';
  }
  return url.replace(/(^\w+:|^)\/\//, '');
};

export const formatPhoneToCallable = (phone?: string) => {
  if (!phone) {
    return '';
  }
  return phone.replace(/[- ]/g, '');
};
